<template>
  <div class="details">
    <h1 class="line">
      {{list.Title}}
      <div v-if="CountDown(list.LastOnTime)!='00:00'" class="OrderType">{{$t('colon.StartingTime')}} {{list.LastOnTime|setTime}} <span :class="getCountDown(list.LastOnTime)==1?'text_red':''">{{$t('colon.timeLeft')}} <em>{{CountDown(list.LastOnTime,0)}}</em></span></div>
    </h1>
    <div class="line price_btn_box">
      <div class="price_btn_box">
        <div class="price_list_box">
          <div class="price_list">
            <span class="price_default">{{$t('colon.price')}}</span>
            <div class="price_us">{{list.Currency}} {{price}}
              <!-- <span class="text_gray line-through" v-if="isDelPrice">{{delPrice}}</span> -->
            </div>
          </div>
          <div class="price_list">
            <span class="price_default sizeText">{{$t('colon.size')}}</span>
            <div class="sizeBox">
              <span class="size" v-for="(item,index) in list.Conditions" :key="index" :class="sizeClass(item)" @click="getConditionId(item,1)">{{item.ConditionName}}</span>
            </div>
          </div>
          <!-- 预售&售罄 不显示-->
          <div class="price_list" v-if="state">
            <span class="price_default">{{$t('colon.quantity')}}</span>
            <el-input-number class="detail_ipt" :disabled="isDisabled" v-model="input" @change="isQuantitySold(list)" :min="1" :max="maxQuantity" label=""></el-input-number>
          </div>
            
          <div v-if="condition&&condition.IsLimit" style="margin-left: 12%;color: #a0a0a0;">{{$tc('base.itemMax',maxQuantity,{ n: maxQuantity })}}</div>
          <el-alert v-if="input<1" :title="$t('alert.enterQuantity')" type="error" show-icon :closable='false'></el-alert>
          <el-alert v-if="input>list.QuantitySold&&list.QuantitySold>0" :title="$t('alert.insufficientInventory')" type="error" show-icon :closable='false'></el-alert>
        </div>
      </div>
      <div class="detail_btn_box" v-if="userInfo!=null&&list.Status>0">
        <div class="detail_btn primary" :class="{'disabled':isDisabled}" @click="goto('buy')">{{$t('base.buyNow')}}</div>
        <div class="detail_btn" :class="{'disabled':isDisabled}" @click="goto('cart')">{{$t('base.addToCart')}}</div>
      </div>
      <div class="detail_btn_box" v-if="userInfo==null">
        <router-link class="detail_btn primary" :to="{path:'/login'}">{{$t('base.buyNow')}}</router-link>
        <router-link class="detail_btn " :to="{path:'/login'}">{{$t('base.addToCart')}}</router-link>
      </div>
    </div>
    <!-- 郵費 -->
    <div class="watchers" v-if="domesticCustom!=null">
      <div class="DomesticCustom">
        <span class="price_name">{{$t('colon.shipping')}}</span>
        <div>
          <div class="Shipping" v-if="domesticCustom!=null">
            <span v-if="domesticCustom.CostType==1">{{$t('base.payOnDelivery')}}</span>
            <span v-if="domesticCustom.CostType!=1&&domesticCustom.FreeDelivery&&domesticCustom.DetailMinimumAmount<=0">{{$t('base.freeShipping')}}</span>
            <span v-if="domesticCustom.CostType!=1&&domesticCustom.FreeDelivery&&domesticCustom.DetailMinimumAmount>0">{{list.Currency}} {{formatAmount(domesticCustom.Cost)}}</span>
            <span v-if="domesticCustom.CostType!=1&&!domesticCustom.FreeDelivery">{{list.Currency}} {{formatAmount(domesticCustom.Cost)}}</span>
          </div>
          <div class="hengxian"></div>
          <span class="text_blue see see_details" @click="domVisible=true">{{$t('base.seeDetails')}}</span>
        </div>
      </div>
      <div class="text_gray freeShipping" v-if="domesticCustom!=null&&domesticCustom.CostType!=1&&domesticCustom.FreeDelivery&&domesticCustom.DetailMinimumAmount>0">Free shipping on {{list.Currency}} {{formatAmount(domesticCustom.DetailMinimumAmount)}}+</div>
    </div>
    <!-- 稅 -->
    <div class="watchers" v-if="userInfo!=null&&condition!=null&&state&&list.MemberSource=='US'">
      <div class="Premium">
        <span class="price_name">{{$t('colon.stateTax')}} </span>
        <div>
          <span>{{list.Currency}} {{formatAmount(condition.FaxPrice)}}</span>
        </div>
      </div>
    </div>
    <cart-dialog :makeVisible="cartVisible" :list="list" :userInfo="userInfo" :shopCart="ShoppingCart" :condition="condition" @getDialog="cartDialog" v-if="cartVisible" />
    <domestic :domVisible="domVisible" :areaSymbol='list.Currency' :list="postageList" v-if="postageList!=null" @getDialog="SetDomDialog" />
    <get-change title="Add Phone Number" :domVisible='dislogType.changePhone' type="1" :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.changePhone' />
    <get-address v-if="dislogType.commodityaddress" :dialogVisible.sync="dislogType.commodityaddress" :isNew='true' @closeDialog="closeDialog" :userInfo.sync="userInfo" />
  </div>
</template>
<script>
import { countDown, getInfo, getTime, setUTC, numMulti, isNumber, formatAmount, priceExchange, isUserDomest, isStoreDomest } from "@/api/public";
import CartDialog from "@/components/dialog/cartdialog"; // 購物車
import Domestic from "@/components/dialog/domesticstore"; // 郵費模板
import GetChange from "@/components/dialog/changePhone"; // 修改手机号或邮箱
import GetAddress from "@/components/dialog/commodityaddress"; // 收货地址
import qs from 'qs'
export default {
  name: 'auction',
  components: { CartDialog, Domestic, GetChange, GetAddress },
  data() {
    return {
      ShoppingCart: {
        areaCode: '',
        buyerId: '',
        commodityId: this.list.ID,
        conditionId: '',
        num: '1',
        coverOrAppend: 1
      },
      isDisabled:false,
      newLimitNum:0,
      areaSymbol: this.$store.state.areaSymbol,
      price: 0,
      delPrice:0,
      isDelPrice:false,
      domesticCustom: null,
      condition: null,
      IsLimit: false,
      maxQuantity: 5,
      state: true, // 商品状态
      dislogType: this.$enumInfo.dislogType,
      userInfo: null,
      domVisible: false,
      dialogVisible: false,
      input: "1",
      cartVisible: false,
      disabled: false,
      timer: "",
      nowData: new Date().getTime(),
      TaxServiceFee: null,
      ServiceFee: null,
      Discount: null,
      SPercent: null,
      DPercent: null,
    }
  },
  props: {
    list: {},
    postageList: {}
  },
  watch: {
    'list': {
      handler(obj) {
        this.domesticCustom = isStoreDomest(this.userInfo, this.postageList)
        this.areaSymbol = this.list.Currency
      }
    },
    'delPrice':{
      handler(val){
        this.isDelPrice=false
        if(isNumber(val)>0){
          this.isDelPrice=true
        }
      }
    },
    'postageList': {
      handler(obj) {

        this.domesticCustom = isStoreDomest(this.userInfo, this.postageList)
      }
    },
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
  },
  mounted() {
    this.isPrice(this.list, 0)
    this.getConditionId(this.list, 0)
    this.domesticCustom = isStoreDomest(this.userInfo, this.postageList)
  },
  created() {
    this.userInfo = getInfo()
    this.areaSymbol = this.list.Currency
    this.cardTimer()
  },
  methods: {
    // 关闭并打开其他弹框
    openCloseDialog(openVal, closeVal, openBol, closeBol) {

      this.dislogType[openVal] = openBol;
      this.dislogType[closeVal] = closeBol;
    },
    formatAmount(obj) {
      return formatAmount(obj)
    },
    // 初始化价格 type:0 初始化，1:选择规格
    isPrice(obj, type) {
      let that = this
      if (type != 0) {
        that.price = obj.ShowPrice ? formatAmount(obj.Price) : '???'
        that.delPrice=obj.ShowPrice ? formatAmount(obj.UnderlinedPrice) : 0
        if (that.state) {
          that.price = formatAmount(obj.Price)
          that.delPrice=formatAmount(obj.UnderlinedPrice)
        }
      } else {
        that.isState(obj)
        if (obj.Conditions) {
          that.price = obj.Conditions[0].ShowPrice ? formatAmount(obj.Conditions[0].Price) : '???'
          if (that.state) {
            that.price = formatAmount(obj.Conditions[0].Price)
            that.delPrice=formatAmount(obj.Conditions[0].UnderlinedPrice)
          }
        } else {
          that.price = '???'
          that.delPrice=0
        }
      }
    },
    //获取种类=> 箱，盒，包 type:0 初始化，1:选择规格
    getConditionId(obj, type) {
      let that = this
      let data = ''
      if (type != 0) {
        if (that.sizeClass(obj) != 'disabled') {
          data = obj
          if (obj.QuantitySold > 0) {
            that.input = 1
            that.isPrice(data)
            that.ShoppingCart.conditionId = data.ID
            that.getConditionRecord(data)
            if (that.CountDown(that.list.LastOnTime) != '00:00' && that.list.Status == 2) {
              that.state = false
            } else {
              that.state = true
            }
          }
        }
      } else {
        var initial = obj.Conditions
        initial = initial.filter(res => {
          return res.QuantitySold > 0
        })
        if (initial.length > 0) {
          data = initial[0]
        } else {
          data = obj.Conditions[0]
        }
        that.isPrice(data, 1)
        that.ShoppingCart.conditionId = data.ID
        that.getConditionRecord(data)
        //console.log(data.QuantitySold,'1231231')
        if (data.QuantitySold <= 0) {
          that.state = false
        }

      }
    },
    getConditionRecord(obj) {
      let that = this

            // that.condition = obj
            // that.setMaxQuantity(obj)
            
      if (obj.IsLimit) {
        that.isDisabled=true
        let data = { AreaCode: that.userInfo.MemberSource, BuyerId: that.userInfo.MappingUserId, CommodityId: that.list.ID, ConditionId: obj.ID }
        that.$get(that.$interface.GetConditionRecord, data).then(res => {
          if (res.Result) {
            obj.newLimitNum =obj.LimitNum-res.Data
            if(obj.newLimitNum<=0){
              obj.newLimitNum=0
            }else{
              that.isDisabled=false
            }
            that.condition = obj
            that.setMaxQuantity(obj)
          } else {
            that.condition = obj
            that.setMaxQuantity(obj)
            that.isDisabled=false
          }
        })
      } else {
        that.condition = obj
        that.setMaxQuantity(obj)
        that.isDisabled=false
      }
    },
    // 设置数量最大值
    setMaxQuantity(obj) {
      let that = this
      that.maxQuantity = obj.QuantitySold
      if (obj.IsLimit) {
        that.IsLimit = obj.IsLimit
        var newLimitNum=obj.LimitNum
        if(obj.newLimitNum!=null){
          newLimitNum=obj.newLimitNum
        }
        that.maxQuantity = newLimitNum
        if (newLimitNum > obj.QuantitySold) {
          that.maxQuantity = obj.QuantitySold
        }
      }
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },

    getCountDown(itemEnd) {
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(i, newval, 0)
    },
    // 获取倒计时
    CountDown(itemEnd) {
      let that=this
      //console.log(itemEnd,'itemEnd')
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      if(that.list.Status==2){
        if(countDown(val, newval) != '00:00'){
          return countDown(val, newval)
        }else{
          that.list.Status=1
          that.isPrice(that.list, 0)
          that.getConditionId(that.list, 0)
          return '00:00'
        }
      }else{
        return '00:00'
      }
    },
    // 商品状态 上架，在仓，某一项买完等@todu 某一项买完没弄
    isState(obj) {
      let that = this
      that.state = true
      if (obj.Status == 0) {
        // console.log('obj.Status')
        that.state = false
      } else {
        if (that.CountDown(obj.LastOnTime) != '00:00' && that.list.Status == 2) {
          that.state = false
        }
      }
    },
    sizeClass(obj) {
      let that = this
      //console.log(that.list,'that.list')
      if (that.list.Status == 0) {
        return 'disabled'
      } else if (that.list.Status == 1) {
        if (obj.QuantitySold <= 0) {
          return 'disabled'
        }
        if (that.ShoppingCart.conditionId == obj.ID) {
          return 'on'
        }
      } else if (that.list.Status == 2) {
        if (obj.QuantitySold <= 0) {
          return 'disabled'
        }
        if (that.ShoppingCart.conditionId == obj.ID) {
          return 'on'
        }
      }
    },
    // 判断商品个数时候小于1或者大于最大值
    isQuantitySold(val) {
      //QuantitySold
      //LimitNumber
      //console.log('判断商品个数时候小于1或者大于最大值', val)
      let that = this
      let max = that.maxQuantity
      let mix = 1
      let now = this.input

      if (now < mix || now >= max) {
        this.disabled = true
      } else {
        this.disabled = false
      }
      //console.log('判断商品个数时候小于1或者大于最大值', this.disabled)
    },
    // 判断默认地址是否为空
    isAddCout() {
      let that = this
      if (!this.userInfo.TelPhone) {
        this.isTelPhone()
      } else {
        this.$confirm(that.$t('alert.noAddress'), that.$t('base.somethingImportant'), {
          confirmButtonText: that.$t('base.goToSet'),
          cancelButtonText: that.$t('base.cancel'),
          lockScroll: false
        }).then(() => {
          that.dislogType['commodityaddress'] = true;
          // let url = this.$router.resolve({ path: '/mycardhobby/setting' })
          // window.open(url.href, '_blank');
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      }
    },
    // 判断用户是否存在手机号
    isTelPhone() {
      this.dislogType['changePhone'] = true;
      // this.$confirm('Please set your Phone number!', 'Something Important', {
      //   confirmButtonText: 'Go to Set',
      //   cancelButtonText: 'Cancel',
      //   lockScroll: false
      // }).then(() => {
      //   let url = this.$router.resolve({ path: '/mycardhobby/setting' })
      //   window.open(url.href, '_blank');
      // }).catch(() => {
      //   // this.$message({
      //   //   type: 'info',
      //   //   message: '已取消删除'
      //   // });          
      // });
    },
    // 关闭添加手机号弹框
    closeDialog(val, bol, type) {
      this.dislogType[val] = bol;
      if (type == 1) {
        this.userInfo = getInfo()
      }
      if (type == 'commodity') {
        this.userInfo = getInfo()
        this.$emit('updateDetail')
      }
    },
    // buyitnow
    buyItNow() {
      let that = this;

      // 官方商城
      // console.log(that.condition, 'Conditions')
      let commodityIds = [{ CommodityId: that.list.ID, ConditionId: that.condition.ID }];
      let cuantitySold = [Number(that.input)];
      let couponMemberID = [0];
      let Subtotal = numMulti(isNumber(that.condition.Price), isNumber(that.input))
      // { "orderId": "4962485704293717703", "total": 9.9, "subtotal": 49.9, "tax": 0.66, "Details": [ { "AreaCode": "US", "StoreName": "", "StoreLogo": "", "CommodityId": "4695787296411666269", "ConditionId": "4941428062559068431", "Num": 1, "NewPrice": 9.9, "ConditionName": "盒子", "Imgs": [ "https://tcg-image.cardhobby.com.cn/2edb2829-9f33-46eb-a9e1-9be648db5534.PNG" ], "Title": "测试商品01", "Currency": "USD" } ] }
      let detail = [{
        AreaCode: that.userInfo.MemberSource,
        StoreName: '',
        StoreLogo: '',
        CommodityId: that.list.ID,
        ConditionId: that.condition.ID,
        Num: Number(that.input),
        Imgs: that.condition.Imgs,
        Title: that.list.Title,
        Currency: that.list.Currency,
        NewPrice: that.condition.Price
      }]
      let data = { total: Subtotal, subtotal: Subtotal, tax: that.condition.FaxPrice, commodityIds: commodityIds, cuantitySold: cuantitySold, couponMemberID: couponMemberID, Details: detail, to: 'buynow' }
      window.sessionStorage.setItem('check', JSON.stringify(data))
      this.$router.push({
        path: '/pay/storecheckout/'
      })
    },
    // 直接购买
    goto(type) {
      let that = this
      if (that.userInfo.VerifyStatus == 2) {
        if (this.state) {
          if (this.userInfo.Count > 0) {
            if (!this.userInfo.TelPhone) {
              this.isTelPhone()
            } else {
              if(!that.isDisabled){
                if (type == 'buy') {
                  this.buyItNow()
                }
                if (type == 'cart') {
                  
                  that.cartVisible = true;
                  //this.SetCart()
                }
              }
            }

          } else {
            this.isAddCout()
          }
        } else {
          if (type == 'cart') {

              if(!that.isDisabled){
                
                that.cartVisible = true;
                //this.SetCart()
              }
          } else {
            this.getComeSoon()
          }
        }
      } else {
        that.dislogType['idverification'] = true;
      }
    },
    // 加入购物车
    SetCart() {
      let that = this;
      that.ShoppingCart.num = isNumber(that.input);
      if (that.userInfo) {
        that.ShoppingCart.areaCode = that.userInfo.MemberSource
        that.ShoppingCart.buyerId = that.userInfo.MappingUserId
        that.$post(this.$interface.SetShopCart, that.ShoppingCart).then(res => {
          if (res.Result != 0) {
            //that.DialogClose()
            that.$router.push({
              path: '/pay/cart'
            })
           // that.cartVisible = true;
          } else {
            that.$message({
              type: 'error',
              message: res.Msg
            });
          }
        })
      }
    },
    getComeSoon() {
      let that = this
      var title = ''
      var html = `<div class="comeBox cardhobby"><span></span>Coming Soon</div>`
      this.$alert(html, title, {
        customClass: 'region',
        confirmButtonText: 'I Know',
        dangerouslyUseHTMLString: true,
        showClose: false,
        lockScroll: false,
        callback: action => {

        }
      });
    },
    cartDialog(val) {
      let value=val
      if(val){
        this.SetCart()
        value=false
      }
      this.cartVisible = value
    },
    // 弹框关闭
    getDialog(val) {
      this.dialogVisible = val
    },
    SetDomDialog(val) {
      this.domVisible = val
    },
    IsUS() {
      this.$emit('isus')
    },
    IsPremium(val) {
      this.$emit('ispremium', val)
    }

  }
}

</script>
<style scoped>
@import "../../../static/css/buynow.css";

.details {
  padding-left: 50px;
  flex: 1;
}

.address_from span {
  display: block;
}

.address_from span:first-child {
  margin-bottom: 16px;
}

.address_from span.earth {
  background: url(/static/images/icon/icon_earth.svg) no-repeat;
  padding-left: 23px;
}

.text_gray {
  margin-left: 96px;
}

.text_gray {
  margin-top: 10px;
}

.freeShipping {
  color: #5F6DAE;
  padding: 4px 8px;
  border-radius: 4px;
  background: #F0F3FF;
  display: inline-block;
}

.OrderType {
  color: #5F6DAE;
}

.OrderType span {
  margin-left: 24px;
}

.price_list_box {
  width: 600px;
}

.price_list .sizeText {
  min-width: 42px;
  margin: 0;
  margin-right: 9px;
}

.sizeBox {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}

.sizeBox .size {
  min-width: 56px;
  border-radius: 2px;
  background: #f7f7f7;
  color: #333;
  text-align: center;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 0 10px;
  cursor: pointer;
}

.sizeBox .size.disabled {
  color: #a0a0a0;
  cursor: no-drop;
}

.sizeBox .size.on {
  color: #fff;
  background: #5F6DAE;
}
.price_us .text_gray{
  margin: auto;
  margin-left: 10px;
  font-size: 22px;
  font-weight: 400;
}

/* /deep/.detail_ipt.el-input-number .el-input__inner{
  height: 40px;
} */
/deep/.detail_ipt.el-input-number {
  line-height: 34px;
}

/* /deep/.detail_ipt .el-input-number__decrease.is-disabled{
    color: #C0C4CC;
    background: #f7f7f7;
}
/deep/.detail_ipt .el-input-number__decrease:hover.is-disabled {
    color: #C0C4CC;
    background: #f7f7f7;
} */

</style>



// WEBPACK FOOTER //
// src/components/detail/buystore.vue